import { useRemoteQuery } from "../useRemote/useRemoteQuery";
import { TeamMember } from "../../../features/Booking-Form/typings/team-member";
import { getOrgBackend } from "../../../app/backend";

export function useRemoteFetchTeamBookingColleagues() {
  return useRemoteQuery<TeamMember[]>({
    queryKey: ["teamBookingColleagues"],
    url: `${getOrgBackend()}/connection/teamBookingColleagues`,
    enabled: true
  });
}
